import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Urls } from '../utilities/urls.component';
import { ProfileResponseDTO } from '../models/ProfileResponseDTO';
import { ProfileRequestDTO } from '../models/ProfileRequestDTO';
import { ResponseDTO } from '../models/ResponseDTO';
import { AllTeamMembersDTO } from '../models/AllTeamMembersDTO';
import { BusinessResponseDTO } from '../models/BusinessResponseDTO';
import { PasswordDTO } from '../models/PasswordDTO';
import { AuthRequestDTO } from '../models/AuthRequestDTO';
import { AuthResponseDTO } from '../models/AuthResponseDTO';
import { Utils } from '../utilities/util.component';

@Injectable()
export class SettingsService {

  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  getProfileInfo(userName: string, request: string) {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.profileInfo + userName;
    return this.http.post<ProfileResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  updateProfileInfo(request: ProfileRequestDTO) {
    if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.updateAdminUser;
      return this.http.post<ResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.updateUser;
    return this.http.post<ResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  getAllUsers(orgName: string) {
    if (Utils.isAdmin() && localStorage.getItem("WhichTeamTab") == 'Organisation') {
      //Organisation Team
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.getAllOrgUsers + orgName;
      return this.http.get<AllTeamMembersDTO>(url, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin() && localStorage.getItem("WhichTeamTab") != 'Notifications') {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.getAllSystemAdminUsers;
      return this.http.get<AllTeamMembersDTO>(url, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.getAllOrgUsers + orgName;
    return this.http.get<AllTeamMembersDTO>(url, this.headers.getCommonHttpHeaders());
  }

  // Always GET /pp/getAllUserByOrganisation/{orgName}. getAllUsers() above returns
  // system admins when the logged-in user is admin and WhichTeamTab is not Organisation.
  getAllUsersByOrganisation(orgName: string) {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.getAllOrgUsers + orgName;
    return this.http.get<AllTeamMembersDTO>(url, this.headers.getCommonHttpHeaders());
  }

  getOrgDetailsByName(orgName: string) {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.getOrgDetailsByName + orgName;
    return this.http.post<BusinessResponseDTO>(url, {}, this.headers.getCommonHttpHeaders());
  }

  getOrgDetailsByName1(orgName: string) {
    var url: string = Urls.API_ENDPOINT + Urls.COMPLIANCE.getOrgDetailsByName + orgName;
    return this.http.post<BusinessResponseDTO>(url, {}, this.headers.getCommonHttpHeaders());
  }

  changePassword(request: AuthRequestDTO) {
    // if (this.isAdmin) {
    //   var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.changeAdminPassword;
    //   return this.http.post<BusinessResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    // }
    // var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.changeUserPassword;
    // return this.http.post<BusinessResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.newPassword;
    return this.http.post<AuthResponseDTO>(url, request, this.headers.getLoginHttpHeaders());
  }

  // changeAdminPassword(request: PasswordDTO) {
  //   var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.changeAdminPassword;
  //   return this.http.post<ResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  // }




  // registerUser(request: CreateUserRequestDTO) {
  //   var url: string = Urls.API_ENDPOINT + Urls.USER.registerUser;
  //   return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  // }

  activateModuleByPartner() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.activateModuleByPartner
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  activateCustomerReport() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.activateCustomerReport
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  showHidePartnerOutage() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.partnerOutageDashboard
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  balancePageCustomFilter() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.balancePageCustomFilter
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  hubValueVolumePageCustomFilter() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.hubValueVolumePageCustomFilter
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  partnerValueVolumePageCustomFilter() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.partnerValueVolumePageCustomFilter
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  whatsNewLink() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.whatsNewLink
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  balancePageNotifcation() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.balancePageNotification
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  hubValueVolumePageNotification() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.hubValueVolumePageNotification
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  partnerValueVolumePageNotification() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.partnerValueVolumePageNotification
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }
  newDashboardPage() {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.newDashboardPage
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

}
